import {useEffect, useState} from "react";

import {useGetOfferDetailApplicationQuery} from "../../offer/api/get_offer_detail";
import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {useAppDispatch} from "../../store/hooks";
import {IAppDispatch} from "../../store/store";
import {useGetVendorDetailApplicationQuery} from "../../vendor/api/get_vendor_detail_application_api";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {PriceVisibilityType} from "../../vendor/types/PriceVisibilityType";
import {getBigDataPriceRange} from "../utils/get_big_data_price_range";
import {useLeadRequiredParams} from "./use_lead_required_params";

export function usePriceConversationPrice() {
    const [isPriceAvailable, setIsPriceAvailable] = useState<boolean | null>(null);
    const [price, setPrice] = useState<number | null>(null);

    const dispatch = useAppDispatch();
    const {vendorId, offerId, propertyId} = useLeadRequiredParams();

    const isCalculationDisabled = !offerId || !propertyId;

    const vendorDetailQuery = useGetVendorDetailApplicationQuery(vendorId, {skip: isCalculationDisabled});
    const propertyDetailQuery = useGetPropertyDetailApplicationQuery(propertyId as number, {skip: isCalculationDisabled});
    const offerDetailQuery = useGetOfferDetailApplicationQuery(offerId as number, {skip: isCalculationDisabled});

    const isSuccess = vendorDetailQuery.isSuccess && propertyDetailQuery.isSuccess && offerDetailQuery.isSuccess;

    useEffect(() => {
        // This calculation is used only in AB test scenario and if it's a property modal
        if (isCalculationDisabled) {
            setIsPriceAvailable(false);
            return;
        }

        if (isPriceAvailable === null && vendorDetailQuery.data && propertyDetailQuery.data && offerDetailQuery.data) {
            const isPriceAvailable = typeof propertyDetailQuery.data.price === "number" && propertyDetailQuery.data.price > 0;

            if (isPriceAvailable) {
                setIsPriceAvailable(true);
                setPrice(propertyDetailQuery.data.price);

                return;
            }

            isLeadModalPriceAvailable(propertyDetailQuery.data, offerDetailQuery.data, vendorDetailQuery.data, dispatch).then((priceAvailable) => {
                setIsPriceAvailable(priceAvailable);
            });
        }
    }, [isSuccess]);

    return {
        isPriceAvailable,
        price
    };
}

async function isLeadModalPriceAvailable(
    property: IPropertyDetailApplication,
    offer: IOfferDetailApplication,
    vendor: IVendorDetailApplication,
    dispatch: IAppDispatch
) {
    const leadModalPriceAvailable = vendor.configuration.price_visibility !== PriceVisibilityType.NEVER && !property.configuration.show_price;

    if (!leadModalPriceAvailable) {
        return false;
    }

    if (property.is_price_set) {
        return true;
    }

    const regionEstimatedPrice = await getBigDataPriceRange(offer, property, dispatch);

    if (regionEstimatedPrice && regionEstimatedPrice.length) {
        return true;
    }

    return false;
}
import {useEffect, useState} from "react";

import {useGetOfferDetailApplicationQuery} from "../../offer/api/get_offer_detail";
import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {useAppDispatch} from "../../store/hooks";
import {IAppDispatch} from "../../store/store";
import {useGetVendorDetailApplicationQuery} from "../../vendor/api/get_vendor_detail_application_api";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {PriceVisibilityType} from "../../vendor/types/PriceVisibilityType";
import {getBigDataPriceRange} from "../utils/get_big_data_price_range";
import {useLeadRequiredParams} from "./use_lead_required_params";

export function usePriceConversationPrice() {
    const [isPriceAvailable, setIsPriceAvailable] = useState<boolean | null>(null);
    const [price, setPrice] = useState<number | null>(null);

    const dispatch = useAppDispatch();
    const {vendorId, offerId, propertyId} = useLeadRequiredParams();

    const isCalculationDisabled = !offerId || !propertyId;

    const vendorDetailQuery = useGetVendorDetailApplicationQuery(vendorId, {skip: isCalculationDisabled});
    const propertyDetailQuery = useGetPropertyDetailApplicationQuery(propertyId as number, {skip: isCalculationDisabled});
    const offerDetailQuery = useGetOfferDetailApplicationQuery(offerId as number, {skip: isCalculationDisabled});

    const isSuccess = vendorDetailQuery.isSuccess && propertyDetailQuery.isSuccess && offerDetailQuery.isSuccess;

    useEffect(() => {
        // This calculation is used only in AB test scenario and if it's a property modal
        if (isCalculationDisabled) {
            setIsPriceAvailable(false);
            return;
        }

        if (isPriceAvailable === null && vendorDetailQuery.data && propertyDetailQuery.data && offerDetailQuery.data) {
            const isPriceAvailable = typeof propertyDetailQuery.data.price === "number" && propertyDetailQuery.data.price > 0;

            if (isPriceAvailable) {
                setIsPriceAvailable(true);
                setPrice(propertyDetailQuery.data.price);

                return;
            }

            isLeadModalPriceAvailable(propertyDetailQuery.data, offerDetailQuery.data, vendorDetailQuery.data, dispatch).then((priceAvailable) => {
                setIsPriceAvailable(priceAvailable);
            });
        }
    }, [isSuccess]);

    return {
        isPriceAvailable,
        price
    };
}

async function isLeadModalPriceAvailable(
    property: IPropertyDetailApplication,
    offer: IOfferDetailApplication,
    vendor: IVendorDetailApplication,
    dispatch: IAppDispatch
) {
    const leadModalPriceAvailable = vendor.configuration.price_visibility !== PriceVisibilityType.NEVER && !property.configuration.show_price;

    if (!leadModalPriceAvailable) {
        return false;
    }

    if (property.is_price_set) {
        return true;
    }

    const regionEstimatedPrice = await getBigDataPriceRange(offer, property, dispatch);

    if (regionEstimatedPrice && regionEstimatedPrice.length) {
        return true;
    }

    return false;
}
